import GetMaxAgeRequest from '@/modules/common/common/models/DXP/requests/GetMaxAgeRequest'

export default class {
  static toRequest(
    businessLine: string,
    insuranceType: string,
    stayAbroadType?: string
  ): GetMaxAgeRequest {
    return new GetMaxAgeRequest({
      businessLine,
      insuranceType,
      stayAbroadType
    })
  }
}
